import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import _, { forEach as _forEach } from 'lodash';
import {importUsers, reverseUsers} from "../../../actions/ListActions";



class UsersImport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFiles:[],
      selectedUrls:[],
      progressInfo:[],
      progressInfoRun:[],
      uploading: false,
      showImportButton: false,
      showReverseButton: false,
      actionType: "",
      showErrors: false,
    };
  }


  componentDidMount = () => {

  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.progressInfo.length > 0 && this.state.uploading === false && this.state.actionType === "import") {
      this.setState({uploading: true})
      this.upload();
    }

    if (this.state.progressInfo.length > 0 && this.state.uploading === false && this.state.actionType === "reverse") {
      this.setState({uploading: true})
      this.upload();
    }

    if(prevProps.pendingUI !== this.props.pendingUI && this.props.pendingUI === false){
      this.setState({progressInfo: [], uploading: false, showImportButton: false, showErrors: true})
    }
    if(prevProps.pendingUI !== this.props.pendingUI && this.props.pendingUI === false && this.state.selectedFiles?.length > 0 ){
      this.setState({showReverseButton: true})
    }
    if(prevState.selectedFiles !== this.state.selectedFiles)
    {
      this.setState({showReverseButton: false})
    }

    if(prevProps.pendingRI !== this.props.pendingRI && this.props.pendingRI === false){
      this.setState({progressInfo: [], uploading: false, showReverseButton: false})
    }

  }


  selectFile = event => {
    this.setState({selectedFiles: event.target.files, progressInfo: [], progressInfoRun: [], showImportButton: true});

    let _selectedUrls = [];
    _forEach(event.target.files, (files, i) => {
      _selectedUrls.push(URL.createObjectURL(files));
    });
    if (_selectedUrls.length === event.target.files.length) {
      this.setState({selectedUrls: _selectedUrls})
    }
  };

  upload = () => {
    let _progressInfosNeu = [...this.state.progressInfo];
    let _selectedFiles = this.state.selectedFiles.length;

    for (let i = 0; i < this.state.selectedFiles.length; i++) {
      let idx = i;
      let file = this.state.selectedFiles[i];
      let formData = new FormData();
      formData.append('file', file);
            const uploadProgress = {
              onUploadProgress: ProgressEvent => {
                _progressInfosNeu[idx].percentage = Math.round((100 * ProgressEvent.loaded) / ProgressEvent.total);
                this.setState({progressInfoRun: this.state.progressInfoRun.concat(_progressInfosNeu)})
              },
            };
            if(this.state.actionType === "import"){
              this.props.importUsers(formData, uploadProgress, _selectedFiles - 1);
              this.setState({actionType:""})
            }
            if(this.state.actionType === "reverse"){
              this.props.reverseUsers(formData, uploadProgress, _selectedFiles - 1);
              this.setState({actionType:""})
            }

      _selectedFiles--;
    }
  };


  uploadSplit = () => {
    /* could upload multiple if needed */
    let _progressInfos = [];
    for (let i = 0; i < this.state.selectedFiles.length; i++) {
      _progressInfos.push({ percentage: 0 });
    }
    this.setState({progressInfo: this.state.progressInfo.concat(_progressInfos), actionType: "import"});
  };

  reverseImport = () => {
    let _progressInfos = [];
    for (let i = 0; i < this.state.selectedFiles.length; i++) {
      _progressInfos.push({ percentage: 0 });
    }
    this.setState({progressInfo: this.state.progressInfo.concat(_progressInfos), actionType: "reverse"});
  }


  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      user,
      location,
    } = this.props;

    const errorsOutput = [];
    const helloworld = ["hello", "world"]



    _forEach(this.props.errorMessages, (errorM, i) => {
      errorM?.duplicate && errorsOutput.push(<p style={{color:"#CF1719"}}>{messages.user_duplicate_import + ": " + errorM.duplicate}</p>);
      errorM?.db_update_errors && errorM.email && errorsOutput.push(<p style={{color:"#CF1719"}}>UpdateError: {errorM.db_update_errors + " - Email: " + errorM.email} </p>);
      errorM?.db_errors && errorsOutput.push(<p style={{color:"#CF1719"}}>Error: {errorM.db_errors}</p>);
      errorM?.success_user && errorsOutput.push(<p style={{color:"#008B00"}}>{messages.user_import_success + ": " + errorM.success_user}</p>);
    });




    return (
      <>
        <div className="padding-25 sm-padding-10" style={{backgroundColor:"#FFFFFF"}}>
          <Breadcrumb
            crumbs={[
              { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
              { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
              { link: null, name: messages.import_users },
            ]}
            className="p-t-0"
          />
          <h1>{messages.import_users}</h1>
        </div>
        <div style={{textAlign:"center"}}>
          <h3>{messages.choice_csv}</h3>
          {this.props.pendingUI ? <Loader/> :
            <>
              <div className="image-upload">
                <label htmlFor="file-input" style={{ display:"block", margin:"0 auto", marginTop:"20px", width:"100px", height:"100px", cursor: 'pointer' }}>
                          <span>
                            <i
                              className="far fa-plus-circle"
                              style={{ color: '#FFFFFF', fontSize: '100px', cursor: 'pointer' }}
                            />
                          </span>
                </label>
                <input id="file-input" type="file" accept=".csv" onChange={(e)=>{this.selectFile(e)}} />
              </div>
              <div>
                {this.state.selectedFiles && this.state.selectedFiles.length > 0 && this.state.showImportButton ?
                    <button style={{display:"block", margin:"0 auto", marginTop:"20px"}} onClick={this.uploadSplit} className="btn btn-success card-button">
                      <i className="far fa-upload"></i><span> {messages.start_import}</span>
                    </button>
                  : <></>}
              </div>
              <div>
                {this.state.showReverseButton ?
                  <button style={{display:"block", margin:"0 auto", marginTop:"20px"}} onClick={this.reverseImport} className="btn btn-warning card-button">
                    <i className="far fa-history"></i><span> {messages.reverse_import}</span>
                  </button>
                  : <></>}
              </div>
            </>}
          <div>
            <p style={{margin:"10px"}}>
              <span>
                {this.props.message && this.props.message === "pending" && messages.import_exec}
                {this.props.message && this.props.message === "fulfilled" && messages.import_success}
                {this.props.message && this.props.message === "rejected" && messages.import_rejected}
                {this.props.message && this.props.message === "pendingRE" && messages.import_execRE}
                {this.props.message && this.props.message === "fulfilledRE" && messages.import_successRE}
                {this.props.message && this.props.message === "rejectedRE" && messages.import_rejectedRE}
              </span>
            </p>
          </div>
          {this.state.showErrors ?
            <div>
            <h3>Warnungen und Hinweise</h3>
            {errorsOutput.length > 0 ? errorsOutput : <span>keine</span>}
          </div>
            : <></>}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.users,
    user: state.login.user,
    pendingUI: state.list.userImport.pendingUI,
    message: state.list.userImport.messageUI,
    pendingRI: state.list.userImport.pendingRI,
    errorMessages: state.list.userImport.errorMessages,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    importUsers: (formData, uploadProgress, _selectedFiles) => {
      dispatch(importUsers(formData, uploadProgress, _selectedFiles));
    },
    reverseUsers: (formData, uploadProgress, _selectedFiles) => {
      dispatch(reverseUsers(formData, uploadProgress, _selectedFiles));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(UsersImport)
  )
);
